import React, { useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable'

export default function CustomDataTable({ globalFilter, pageResetKey, children, ...props }) {
  const [first, setFirst] = useState(0)
  const [previousFilter, setPreviousFilter] = useState(globalFilter)

  // Reseta a página para 1 quando o globalFilter muda
  useEffect(() => {
    if (globalFilter !== previousFilter) {
      setFirst(0)
      setPreviousFilter(globalFilter)
    }
  }, [globalFilter, previousFilter])

  useEffect(() => {
    setFirst(0)
  }, [pageResetKey])

  return (
    <DataTable
      {...props}
      globalFilter={globalFilter}
      first={first}
      onPage={e => {
        setFirst(e.first)
        if (props.onPage) {
          props.onPage(e)
        }
      }}
    >
      {children}
    </DataTable>
  )
}
